import { use_slice_generation } from '@/hooks/store/use_slices';
import { INVOCATION__base } from '@shared/dto/generation/graph_invoke/_invocations/_base/INVOCATION__base';
import { useMemo } from 'react';

export function HOOK_INVOCATION__has_effect_on_generation(invocation: INVOCATION__base) {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { graph } = generation_current.tool;

  const out = useMemo(() => get_has_effect_on_generation(), [graph, invocation]);

  function get_has_effect_on_generation() {
    let out = graph.node__has_effect_on_generation_runtime(invocation);

    return out;
  }

  return out;
}
